import { initTranslation } from "../modules/i18n";
import initPage from "../modules/page";
import "../../scss/about.scss";

async function initAboutPage() {
  await initTranslation();
  initPage();
}

initAboutPage();
